export const roundNumber = (number: number, decimals: number) =>
  Math.round((number + 0.00001) * Math.pow(10, decimals)) /
  Math.pow(10, decimals);

// https://stackoverflow.com/a/11832950
export const roundToMax2Decimals = (num: number) =>
  Math.round((num + Number.EPSILON) * 100) / 100;
